import moment from 'moment';
import formats from './inputs/formats';
import isObject from 'lodash/isObject';
import range from 'lodash/range';
import flatten from 'lodash/flatten';
import bson from 'bson-objectid';

// prefill(tmap, fieldIndex) OR prefill(tmap, rowName, fieldIndex)
export default function prefill(tmap, ...args) {
  return tmap
    ? args.length > 1
      ? prefillMatrix(tmap, args[0], args[1], args[2])
      : prefillSimple(tmap, args[0])
    : '';
}

function prefillSimple(tmap, index = 0) {
  return getValue(tmap, index);
}

function prefillMatrix(tmap, rowName, fieldIndex, opts) {
  const key = opts && opts.key ? opts.key : undefined;
  return getValue(tmap[rowName], fieldIndex, key);
}

export function prefillMatrixSelect(tmap, rowName) {
  return tmap && tmap[rowName] ? tmap[rowName] : [];
}

function getValue(values, index, key = 'values') {
  return Array.isArray(values)
    ? values[index] || ''
    : isObject(values)
      ? getValue(values[key], index)
      : values || '';
}

export const prefillOther = (questionName, tmap) => {
  const key = `${questionName}-other-value`;
  return getValue(tmap[key], 0);
};

export const prefillWhy = (questionName, tmap) => {
  const key = `${questionName}-why`;
  return tmap ? getValue(tmap[key], 0) : '';
};

/*
sometimes the tmap comes down as a map with named fields. we can't simply
convert this into an array because we don't know the intended order of the
fields. so we have to manually deconstruct these
*/

export function prefillMultipart(tmap, index, composite_type) {
  if (tmap) {
    const fieldNames = multipartFieldNames(composite_type);
    const field = tmap[fieldNames[index]];
    return field ? field[0] : '';
  } else {
    return '';
  }
}

export function multipartFieldNames(composite_type) {
  switch (composite_type) {
    case 'address':
      return ['street1', 'street2', 'city', 'state', 'zip', 'country'];
    case 'us_address':
      return ['street1', 'street2', 'city', 'state', 'zip'];
    case 'age':
      return ['month', 'day', 'year'];
    case 'phone':
      return ['area_code', 'exchange', 'subscriber'];
  }
}

export function prefillDatetime(tmap, field_type, ...args) {
  const value = prefill(tmap, ...args);
  const formatStr = formats[field_type];
  const date = moment.utc(value, [formatStr, moment.ISO_8601]);
  return date.isValid() ? date.format(formatStr) : value;
}

export const prefillHeatmap = ({ tmap = {} }) => state => {
  const rowNames = Object.keys(tmap).filter(name => name.match(/row/));
  const zippedTmap = rowNames.reduce(
    (acc, rowName) => ({ ...acc, [rowName]: zipHeatmapRow(tmap[rowName]) }),
    {}
  );
  const flattenedTmap = flatten(rowNames.map(name => zippedTmap[name]));

  const markers = flattenedTmap.reduce(
    (acc, marker) => ({ ...acc, [marker.key]: marker }),
    {}
  );
  const notes = flattenedTmap.reduce(
    (acc, marker) => ({ ...acc, [marker.key]: marker.note }),
    {}
  );
  const times = flattenedTmap.reduce(
    (acc, marker) => ({ ...acc, [marker.key]: marker.time }),
    {}
  );
  const markerValids = flattenedTmap.reduce(
    (acc, marker) => ({ ...acc, [marker.key]: true }),
    {}
  );
  const rows = state.rows.map(row => ({
    ...row,
    keys: zippedTmap[row.name] ? zippedTmap[row.name].map(m => m.key) : [],
  }));
  return { ...state, markers, markerValids, notes, rows, times };
};

function zipHeatmapRow(row) {
  return range(row.x.length).map(idx => {
    return {
      x: +row.x[idx],
      y: +row.y[idx],
      note: row.comment ? row.comment[idx] : null,
      time: row.time ? +row.time[idx] : null,
      key: bson().str,
    };
  });
}
